<template>
	<DefaultLayout>
		<Dialog title="Help" class="Center">
		    <p>Use your keyboard to navigate the menu. Use ALT-keys to select the different tabs.</p>
		    <p>This app is the result of one of Athom's Hacky Fridays, so official support is not available.</p>
		    <Button @onPress="backPress" title="Back"/>
		</Dialog>
	</DefaultLayout>
</template>

<script>
	import { Component, Vue } from 'vue-property-decorator';
    import DefaultLayout from '../../layouts/Default/index.vue';
    import Dialog from '../../components/Dialog';
    import Button from '../../components/Button';
    import KeyListenerView from '../../components/KeyListenerView';

	@Component({
		components: {
			DefaultLayout,
			Dialog,
			Button,
		},
	})
	export default class HelpView extends KeyListenerView {
    	
    	mounted() {
        	this.addKeyboardListener('ESC', this.backPress);
        	this.addKeyboardListener('BACKSPACE', this.backPress);
        	super.mounted();
    	}
    	
    	destroyed() {
        	super.destroyed();
    	}
    	
    	backPress() {
        	this.$router.go(-1);
    	}
	}
</script>

<style lang="scss">

</style>